import { AppliedQueryFilters } from 'components/QueryFilters'

import { useFilterSearchParams } from '../../hooks/useFilterSearchParams'
import { useVisitsFilter } from '../../hooks/useVisitsFilter'

interface AppliedFiltersProps {
  /**
   * Tags are display only and cannot be modified
   */
  isDisabled?: boolean
}

export function AppliedFilters({ isDisabled = false }: AppliedFiltersProps) {
  const { filterValues, setSearchParams } = useFilterSearchParams()
  const { filterItems } = useVisitsFilter()

  return (
    <AppliedQueryFilters
      filterDefinitions={filterItems}
      filterValues={filterValues}
      onChange={setSearchParams}
      isDisabled={isDisabled}
      dataTestId='visit-history-applied-filters'
      filterItemTestId='visit-history-filter-item'
    />
  )
}
